import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';
import ProjEditNumberDom from './ProjEditNumberDom';
import ProjEditStringDom from './ProjEditStringDom';
import ProjEditTextareaDom from './ProjEditTextareaDom';
import ProjEditTimeDom from './ProjEditTimeDom';
import ProjEditPtypeDom from './ProjEditPtypeDom';
import ProjEditIntervalDom from './ProjEditIntervalDom';
import ProjEditImageDom from './ProjEditImageDom';
import ProjEditImageAryDom from './ProjEditImageAryDom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons"
import api from '../../api';

const ETYPE = {
    STRING: 0,
    NUMBER: 1,
    TIME: 2,
    OPTIONS: 3,
    EMPTY: 4,
    INTERVAL: 5,
    NO_DATA: 6,
    TEXT_AREA: 7,
    IMAGE: 8,
    IMAGE_ARY: 9
};

export default class ProjEditForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.formData,
            isDisabled: null == props.isDisabled ? true : props.isDisabled,
            tmpData: null
        };
        if (false == this.state.isDisabled) {
            this.state.tmpData = this.state.data;
        }
        console.log("[ProjEditForm] props", props, this.state);

        this.onChange = this.onChange.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.getDom = this.getDom.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        console.log(nextProps, nextState);

        if (this.state.data != nextProps.formData) {
            this.setState({
                data: nextProps.formData,
            });
            return false;
        }

        return true;
    }

    onChange(key, newValue) {
        // console.log(key, newValue);
        // if (key == "interval") {
        //     this.setState({
        //         tmpData: {
        //             ...this.state.tmpData,
        //             interval_year: newValue.year,
        //             interval_month: newValue.month,
        //             interval_day: newValue.day
        //         }
        //     });
        // } else {
        this.setState({
            tmpData: {
                ...this.state.tmpData,
                [key]: newValue
            }
        });
        // }
    }


    onEdit() {
        this.setState({
            isDisabled: false,
            tmpData: this.state.data
        });
    }

    onCancel() {
        this.setState({
            isDisabled: true
        });
    }

    onSubmit() {
        console.log("onSubmit", this.state);
        //API
        this.props.onUpdate(this.state.tmpData);
        // window.open(this.props.history.createHref({
        //     pathname: "/proj/detail/" + this.state.pid
        // }));
    }

    getDom(index, value, key, currentData, isDisabled) {
        const onChange = this.onChange;
        // console.log(currentData);
        switch (value.type) {
            case ETYPE.NO_DATA:
                return (
                    <Col key={index} className="mb-2">
                        <label>{value.name}</label>
                        <div class="form-row">
                            <Col><input disabled type="text" class="form-control" placeholder="沒資料啊ＱＱ" /></Col>
                        </div>
                    </Col>
                );
            case ETYPE.EMPTY:
                return (<Col key={index} className="mb-78"></Col>);
            // return (<Col className="mb-2">
            //     <label>aa</label>
            //     <input class="form-control" type="text" value="" />
            // </Col>);
            case ETYPE.OPTIONS:
                return (
                    <ProjEditPtypeDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.NUMBER:
                return (
                    <ProjEditNumberDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.STRING:
                return (
                    <ProjEditStringDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.TEXT_AREA:
                return (
                    <ProjEditTextareaDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.IMAGE:
                return (
                    <ProjEditImageDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                        pid={this.state.data.pid}
                    />
                );
            case ETYPE.IMAGE_ARY:
                return (
                    <ProjEditImageAryDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                        pid={this.state.data.pid}
                    />
                );
            case ETYPE.TIME:
                return (
                    <ProjEditTimeDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.INTERVAL:
                return (
                    <ProjEditIntervalDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        year={currentData.interval_year || 0}
                        month={currentData.interval_month || 0}
                        day={currentData.interval_day || 0}
                        onChange={onChange}
                    />
                );
            // default:
            //     tmp.push( className="mb-2");
            //     break;
        }
    }


    render() {
        const { title, isAddProj } = this.props;
        const { data, isDisabled, tmpData } = this.state;
        // const { onChange } = this;
        const currentData = isDisabled ? data : tmpData;
        console.log(isDisabled, currentData);

        let listAryLeft = [
            { key: "p_type", name: "問卷類型", isRequired: true, type: ETYPE.OPTIONS, options: ["一次性", "通行碼", "週期", "健康", "測試(訪查用)"] },
            { key: "name", name: "問卷名稱", isRequired: true, type: ETYPE.STRING },
            { key: "point", name: "贈送點數", isRequired: true, type: ETYPE.NUMBER },
            { key: "extra_point", name: "額外贈點", isRequired: true, type: ETYPE.NUMBER },
            { key: "cash_point", name: "現金贈點", isRequired: true, type: ETYPE.STRING },
            { key: "max_people", name: "回收上限", isRequired: true, type: ETYPE.STRING },
            { key: "start_at", name: "開始時間", isRequired: true, type: ETYPE.TIME },
            { key: "end_at", name: "結束時間", isRequired: true, type: ETYPE.TIME },
            { key: "source", name: "問卷來源", isRequired: true, type: ETYPE.STRING },
            { key: "is_top", name: "問卷置頂", isRequired: true, type: ETYPE.OPTIONS, options: ["否", "是"] },
            { key: "is_recom", name: "強力推薦", isRequired: true, type: ETYPE.OPTIONS, options: ["否", "是"] },
            // { key: "empty4", name: "發送對象", isRequired: false, type: ETYPE.NO_DATA },
        ];
        let listAryRight = [
            { key: "empty", type: ETYPE.EMPTY },
            { key: "start_page", name: "問卷起始語", isRequired: true, type: ETYPE.STRING },
            { key: "end_page", name: "問卷結尾語", isRequired: true, type: ETYPE.STRING },
            // { key: "empty5", name: "問卷額滿語", isRequired: false, type: ETYPE.NO_DATA },
            { key: "description", name: "問卷說明", isRequired: true, type: ETYPE.TEXT_AREA },
            { key: "icon", name: "主圖 750*350", isRequired: true, type: ETYPE.IMAGE },
            { key: "images", name: "內頁圖 750*350", isRequired: true, type: ETYPE.IMAGE_ARY },
            { key: "is_del", name: "是否刪除", isRequired: false, type: ETYPE.OPTIONS, options: ["否", "是"] },
            { key: "tag", name: "問卷標籤", isRequired: false, type: ETYPE.STRING },
            // //p_type = 1
            // { key: "pass", name: "通⾏行行碼", isRequired: false, type: ETYPE.STRING },
            // //p_type = 2
            // { key: "interval_year", name: "每N年", isRequired: false, type: ETYPE.STRING },
            // { key: "interval_month", name: "每N月", isRequired: false, type: ETYPE.STRING },
            // { key: "interval_day", name: "每N日", isRequired: false, type: ETYPE.STRING },
        ];
        if (isAddProj == true) {
            listAryRight.splice(6, 1);
        }

        // console.log("[ProjEditForm] ", this.state);
        let tmpLeft = [], tmpRight = [];

        if (currentData) {
            switch (currentData.p_type) {
                case 0:
                case "0":
                    listAryRight[0] = { key: "empty", type: ETYPE.EMPTY };
                    break;
                case 1:
                case "1":
                    listAryRight[0] = { key: "pass", name: "通行碼", isRequired: true, type: ETYPE.STRING };
                    break;
                case 2:
                case "2":
                    listAryRight[0] = { key: "interval", name: "週期", isRequired: true, type: ETYPE.INTERVAL };
                    break;
            }
            // console.log(currentData.p_type, listAry);

            for (const [index, value] of Object.entries(listAryLeft)) {
                const key = value.key;
                tmpLeft.push(this.getDom(index, value, key, currentData, isDisabled));
            }

            for (const [index, value] of Object.entries(listAryRight)) {
                const key = value.key;
                tmpRight.push(this.getDom(index, value, key, currentData, isDisabled));
            }
        }

        let btns = (
            <>
                <Col className="col-12 col-md-5 offset-md-1">
                    {/* <h1>{title}</h1> */}
                </Col>
                <Col className="col-12 col-md-5 text-right">
                    <Button className="m-2" variant="secondary" type="button" onClick={this.props.onCancel}>取消</Button>
                    <Button className="m-2" variant="primary" type="button" onClick={this.onSubmit}>送出</Button>
                </Col>
            </>
        );
        if (true == isDisabled) {
            btns = (
                <>
                    <Col className="col-12 col-md-6">
                        <Button className="m-2" variant="primary" type="button" onClick={this.props.onDownloadMember}>
                            <FontAwesomeIcon
                                icon={Icons.faFileDownload}
                                style={{ float: "left" }}
                            />
                        </Button>
                        <Button className="m-2" variant="primary" type="button" onClick={this.props.onDownloadRecord}>
                            <FontAwesomeIcon
                                icon={Icons.faFileDownload}
                                style={{ float: "left" }}
                            />
                        </Button>
                        <Button className="m-2" variant="primary" type="button" onClick={this.props.onDownloadQuestion}>
                            <FontAwesomeIcon
                                icon={Icons.faFileDownload}
                                style={{ float: "left" }}
                            />
                        </Button>
                    </Col>
                    <Col className="col-12 col-md-6 text-right">
                        <Button className="m-2" variant="primary" type="button" onClick={this.onEdit}>修改</Button>
                        <Button className="m-2" variant="primary" type="button" onClick={this.props.onCopy}>複製</Button>
                        <Button className="m-2" variant="primary" type="button" onClick={this.props.onDel}>刪除</Button>
                    </Col>
                </>
            );
        }

        return (
            <>
                <Row>
                    <Col className="col-md-10 mx-auto col">
                        <Container>
                            <Row className="pt-5">
                                {btns}
                            </Row>
                            <form>
                                <div className="form-group row">
                                    <Col className="col-12 col-md">
                                        <Row className="d-flex flex-column">
                                            {tmpLeft}
                                        </Row>
                                    </Col>
                                    <Col className="col-12 col-md">
                                        <Row className="d-flex flex-column">
                                            {tmpRight}
                                        </Row>
                                    </Col>
                                </div>
                            </form>
                        </Container>
                    </Col>
                </Row>
            </>
        );
    }
}
